import React, { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
const display = value => value == null ? "" : typeof value === "string" ? value : String(Number(Number(value).toFixed(8)));

export const ReviewCell = ({ row, prefix, editable, onCommit, onEditing }) => {
  const [text, setText] = useState(display(row.value));
  const [error, setError] = useState("");
  const focused = useRef(false), changed = useRef(false);
  useEffect(() => () => onEditing(row.key, false), [onEditing, row.key]);
  useEffect(() => { if (!focused.current) setText(display(row.value)); }, [row.value]);
  const commit = () => {
    focused.current = false;
    if (!changed.current) { setText(display(row.value)); return; }
    const normalized = text.trim().replace(",", ".");
    if (row.kind === "cava") {
      if (!/^\d+(\.\d+)?(\/\d+(\.\d+)?°)?$/.test(normalized)) { setError("Inserisci la cava completa, ad esempio 16 o 20/60°."); return; }
      const parts = normalized.replace("°", "").split("/").map(Number);
      if (parts.some(x => x <= 0 || !Number.isFinite(x))) { setError("Cava non valida."); return; }
      changed.current = false; setError(""); onEditing(row.key, false);
      onCommit(row.key, parts.join("/") + (parts.length === 2 ? "°" : "")); return;
    }
    const value = normalized === "" ? NaN : Number(normalized);
    if (!Number.isFinite(value) || value < row.minimum || value > row.maximum || (row.integer && !Number.isInteger(value))) {
      setError(row.integer ? "Inserisci un conteggio intero valido." : "Inserisci un numero valido nell’intervallo consentito.");
      return;
    }
    changed.current = false; setError(""); onEditing(row.key, false);
    onCommit(row.key, value);
  };
  return <div className="min-w-0">
    <Input data-testid={`${prefix}-input-${row.key.replaceAll("_", "-")}`} aria-label={`${row.label} (${row.unit})`} aria-invalid={!!error}
      className="h-8 w-full min-w-0 font-mono text-right text-xs" inputMode={row.kind === "cava" ? "text" : row.integer ? "numeric" : "decimal"} disabled={!editable}
      list={row.kind === "cava" ? `${prefix}-options-${row.key}` : undefined}
      value={text} onFocus={() => { focused.current = true; }}
      onChange={e => { setText(e.target.value); changed.current = true; onEditing(row.key, true); setError(""); }} onBlur={commit}
      onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); e.currentTarget.blur(); }
        if (e.key === "Escape") { changed.current = false; setText(display(row.value)); setError(""); onEditing(row.key, false); e.currentTarget.blur(); } }} />
    {error && <p role="alert" data-testid={`${prefix}-invalid-${row.key.replaceAll("_", "-")}`} className="text-xs text-destructive mt-1">{error}</p>}
    {row.kind === "cava" && <datalist id={`${prefix}-options-${row.key}`} data-testid={`${prefix}-options-${row.key.replaceAll("_", "-")}`}>
      {(row.options || []).map((option, i) => <option key={option} value={option} data-testid={`${prefix}-option-${row.key.replaceAll("_", "-")}-${i}`} />)}
    </datalist>}
  </div>;
};